import { alpha, Components, svgIconClasses, Theme, toggleButtonClasses } from '@mui/material';

/**
 * Component overrides (i.e. global styles, default props) applied to
 * MuiToggleButton to make it match the design system.
 *
 * See: https://mui.com/material-ui/api/toggle-button#css
 */
export const MuiToggleButton: Components<Theme>['MuiToggleButton'] = {
  styleOverrides: {
    root: ({ theme }) => {
      if (theme.featureFlags.panwRebrandStubYear) {
        return {
          fontSize: theme.typography.body1.fontSize,
          fontWeight: 'normal',
          padding: '5px 12px',

          color: theme.palette.input.placeholderColor,
          borderColor: theme.palette.border.bold,
          borderRadius: theme.shape.controlRadius,

          [`&.${toggleButtonClasses.selected}`]: {
            backgroundColor: `${theme.palette.interactive.neutral.active} !important`,
          },
          '&:hover, &:focus': {
            backgroundColor: `${theme.palette.interactive.neutral.hover} !important`,
          },

          [`&.${toggleButtonClasses.disabled}`]: {
            color: theme.palette.text.disabled,
            borderColor: theme.palette.border.bold,
          },

          // For some reason the selected override doesn't work at the moment, so
          // target it this way instead. Higher specificity is necessary to override
          // removing the left border on buttons in the group besides the first
          [`&.${toggleButtonClasses.root}.${toggleButtonClasses.root}.${toggleButtonClasses.selected}`]: {
            color: theme.palette.text.primary,
            borderColor: theme.palette.border.bold,
            [`&.${toggleButtonClasses.disabled}`]: {
              color: theme.palette.text.disabled,
            },
          },

          '.Chronoui-startIcon': {
            marginRight: '4px',
            lineHeight: '10px',
          },

          [`.${svgIconClasses.root}`]: {
            width: '20px',
            height: '20px',
          },
        };
      }

      return {
        fontSize: 14,
        fontWeight: 'normal',
        padding: '5px 12px',

        color: theme.palette.text.primary,
        borderColor: theme.palette.border.bold,

        [`&.${toggleButtonClasses.disabled}`]: {
          borderColor: theme.palette.border.bold,
          // alpha value needed to display separator borders due to negative margins
          backgroundColor: alpha(theme.palette.background.hover, 0.5),
        },

        // For some reason the selected override doesn't work at the moment, so
        // target it this way instead. Higher specificity is necessary to override
        // removing the left border on buttons in the group besides the first
        [`&.${toggleButtonClasses.root}.${toggleButtonClasses.root}.${toggleButtonClasses.selected}`]: {
          backgroundColor: theme.palette.primary.lowContrast,
          borderColor: theme.palette.primary.main,
          [`&:hover`]: {
            backgroundColor: theme.palette.primary.lowContrast,
          },
        },

        '.Chronoui-startIcon': {
          marginRight: '4px',
          lineHeight: '10px',
        },

        [`.${svgIconClasses.root}`]: {
          width: '20px',
          height: '20px',
        },
      };
    },
  },
};
